module.exports = __webpack_public_path__ + "media/evolve/assets/icons/planned/keyboard-template-d38e866a41b1e7f87b5adec3f4846f51.svg";